import { render, staticRenderFns } from "./PartnersPage.vue?vue&type=template&id=7a4462a9&scoped=true"
import script from "./PartnersPage.vue?vue&type=script&lang=js"
export * from "./PartnersPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4462a9",
  null
  
)

export default component.exports